import type { ReactElement } from 'react'

import { Button } from '../Button/Button'
import { Modal } from './Modal'
import styles from './modal.module.scss'

export type ConfirmDialogProps = {
  open: boolean
  title: string
  message: string
  /** `danger` for anything that removes or deactivates. */
  variant?: 'default' | 'danger'
  confirmLabel?: string
  cancelLabel?: string
  onConfirm: () => void
  onCancel: () => void
  /** While the mutation is in flight: both buttons go disabled. */
  isLoading?: boolean
}

/**
 * The confirmation every destructive action goes through — removing a type from
 * a group, unassigning somebody, deactivating a user. Built on `Modal`, so Esc
 * and the backdrop behave the same as everywhere else.
 */
export const ConfirmDialog = ({
  open,
  title,
  message,
  variant = 'default',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
  isLoading = false,
}: ConfirmDialogProps): ReactElement => (
  <Modal open={open} title={title} onClose={onCancel} maxWidth="44rem">
    <p className={styles['confirm-dialog__message']}>{message}</p>
    <div className={styles['confirm-dialog__actions']}>
      <Button variant="secondary" onClick={onCancel} disabled={isLoading} label={cancelLabel} />
      <Button
        variant={variant === 'danger' ? 'danger' : 'primary'}
        onClick={onConfirm}
        disabled={isLoading}
        label={confirmLabel}
      />
    </div>
  </Modal>
)
